export abstract class LoginService {
    visible: boolean;
    abstract show(): void;
    abstract hide(): void;
    abstract nwShow(): void;
}

export function LoginServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Login');
}

export const LoginServiceProvider = {
    provide: LoginService,
    useFactory: LoginServiceFactory,
    deps: ['$injector']
};
